import { background, text } from '@/theme/colors/palettes';
import { TRecommendation } from '@/types/Health.types';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

const SubdomainRecommendationSection = ({
  recommendation: { title, bullets },
}: {
  recommendation: TRecommendation;
}) => {
  return (
    <VStack padding={'16px'} backgroundColor={background.lightBlue} rounded={'12px'} alignItems={'start'}>
      <Text variant={'urbanistBold'} color={text.darkBlue} style={{ fontSize: 16 }} textAlign={'start'}>
        {title}
      </Text>
      <VStack gap={3} marginTop={'4px'} alignItems={'start'}>
        {bullets.map((bullet) => (
          <Text
            variant={'urbanistSemiBold'}
            color={text.mediumBlue}
            style={{ fontSize: 16 }}
            key={bullet}
            textAlign={'start'}
          >
            — {bullet}
          </Text>
        ))}
      </VStack>
    </VStack>
  );
};

export default SubdomainRecommendationSection;
